import type { SVGProps } from "react";

export default function SolarDatabaseLinear(props: SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
            <g fill="none" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" d="M4 18V6M20 6v12" />
                <path d="M12 10c4.418 0 8-1.791 8-4s-3.582-4-8-4-8 1.791-8 4 3.582 4 8 4Z" />
                <path d="M20 12c0 2.209-3.582 4-8 4s-8-1.791-8-4" />
                <path d="M20 18c0 2.209-3.582 4-8 4s-8-1.791-8-4" />
            </g>
        </svg>
    );
}
